import { Suspense, lazy } from 'react';
import { getModuleLoader } from '../../common/moduleResolver';

const MissingModule = ({ moduleName }: { moduleName: string }) =>
    import.meta.env.PROD ? (
        <></>
    ) : (
        <div className='bg-red-40 text-center p-sm'>
            <strong>{moduleName}</strong> module missing.
        </div>
    );

export const ModuleLoader = ({
    moduleName,
    ...params
}: {
    moduleName: string;
} & Record<string, string>) => {
    const loader = getModuleLoader(moduleName);

    if (!loader) {
        return <MissingModule moduleName={moduleName} />;
    }

    const LazyModule = lazy(loader);

    return (
        <Suspense>
            <LazyModule {...params} />
        </Suspense>
    );
};
export default ModuleLoader;
